<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="List of Maps">
<p class="h1" id="ch-1"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><a href="#/text/9780253044174_Contents#ch1"><b>LIST OF MAPS</b></a></span></p>
<p class="hano" id="rmap1"><a href="#/text/9780253044174_Abbreviations#map1">Map 1: Far East Asia</a></p>
<p class="hano" id="rmap2"><a href="#/text/9780253044174_Abbreviations#map2">Map 2: Proposed Sites for the Naval Base</a></p>
<p class="hano" id="rmap3"><a href="#/text/9780253044174_Abbreviations#map3">Map 3: Malaya</a></p>
<p class="hano" id="rmap4"><a href="#/text/9780253044174_Abbreviations#map4">Map 4: Japanese Advance in the Malayan Peninsula</a></p>
<p class="hano" id="rmap5"><a href="#/text/9780253044174_Abbreviations#map5">Map 5: Japanese Attack on Northern Malaya, 7/8 December 1941</a></p>
<p class="hano" id="rmap6"><a href="#/text/9780253044174_Abbreviations#map6">Map 6: Kota Bahru, 8 December 1941</a></p>
<p class="hano" id="rmap7"><a href="#/text/9780253044174_Abbreviations#map7">Map 7: Jitra</a></p>
<p class="hano" id="rmap8"><a href="#/text/9780253044174_Abbreviations#map8">Map 8: WESTFORCE Disposition in Johore, 14 January 1942</a></p>
<p class="hano" id="rmap9"><a href="#/text/9780253044174_Abbreviations#map9">Map 9: Northern Johore, 15 January 1942</a></p>
<p class="hano" id="rmap10"><a href="#/text/9780253044174_Abbreviations#map10">Map 10: Johore Bahru, January 1942</a></p>
<p class="hano" id="rmap11"><a href="#/text/9780253044174_Abbreviations#map11">Map 11: Disposition of Troops on Singapore Island, 8 February 1942</a></p>
<p class="hano" id="rmap12"><a href="#/text/9780253044174_Abbreviations#map12">Map 12: Japanese Attack, Singapore, February 1942</a></p>
<p class="hano" id="rmap13"><a href="#/text/9780253044174_Abbreviations#map13">Map 13: The Japanese Assault and Advance and the Final Defense of the Perimeter, Singapore</a><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253044174_Maps.vue?1020761f